import styled from 'styled-components';
import AddTalentToJob from '@/components/AddTalentToJob';
import Board from '@/components/Board';
import JobResumeComponent from '@/components/JobResume';
import TableOfContentSidebar from '@/components/TableOfContentSidebar';

export const Sidebar = styled(TableOfContentSidebar)`
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    top: 67px;
  }
`;

export const Content = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 70%;
  min-width: calc(100% - 300px);
`;

export const ListContent = styled.div`
  padding-top: 16px;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    display: flex;
    justify-content: space-between;
    gap: 24px;
    flex-direction: row;
  }
`;

export const SubHeader = styled.div`
  display: flex;
  border-bottom: 1px solid ${({ theme }) => theme.colors['neutral-40']};
  height: 64px;
  align-items: center;
  gap: 32px;
  margin-left: -20px;
  margin-right: -20px;
  padding-left: 20px;
  padding-right: 20px;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    margin-left: -100px;
    margin-right: -100px;
    padding-left: 100px;
    padding-right: 100px;
  }
`;

export const JobResume = styled(JobResumeComponent)`
  margin-bottom: 0;
`;

export const CandidateCategoryBox = styled.div`
  background-color: ${({ theme }) => theme.colors['neutral-0']};
  border: 1px solid ${({ theme }) => theme.colors['neutral-30']};
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.07);
  border-radius: 16px;
  padding: 32px;
`;

export const CandidateCategoryBoxTitleContainer = styled.div`
  display: flex;
  gap: 8px;
  font-size: 16px;
  line-height: 30px;
  margin-bottom: 16px;

  > strong {
    font-weight: 600;
  }
`;

export const CandidateBoxEmptyState = styled.p`
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
`;

export const CandidateList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const BoardContent = styled.div`
  display: block;
  padding-top: 16px;
  height: calc(100vh - 284px);
  margin-left: -20px;
  margin-right: -20px;
  padding-left: 20px;
  padding-right: 20px;
  width: 100%;
  box-sizing: content-box;
  overflow-x: auto;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    margin-left: -100px;
    margin-right: -100px;
    padding-left: 100px;
    padding-right: 100px;
  }
`;

export const BoardCards = styled(Board.Cards)`
  padding-bottom: 6px;
`;

export const CandidateSearch = styled(AddTalentToJob)`
  max-width: ${({ showInput }) => (showInput ? '496' : '103')}px;
  transition: max-width 0.3s ease-out;
  flex-grow: 1;
`;

export const Grow = styled.div`
  flex-grow: 1;
`;
